<script>
    import ChevronRight from 'lucide-svelte/icons/chevron-right';

    export let topic = {};
    export let copy = [];
    export let stories = [];

    topic = JSON.parse(topic).table;
    copy = JSON.parse(copy);
    stories = JSON.parse(stories).map((s) => s.table);
</script>

<div class="home-readmore-wrapper readmore">
    <div class="home-middle">
        <h2 class="readmore__header">
            More from <a href={topic.url}>{topic.label} <ChevronRight /> </a>
        </h2>

        {#each copy as p}
            <p class="readmore__copy">
                {@html p.table.value}
            </p>
        {/each}

        <ul class="readmore__items">
            {#each stories as s}
                <li class="readmore__items__item">
                    <a href={s.url}>
                        <img class="story-card__art" src={s.image} alt={s.headline} />
                    </a>

                    <a href={s.url}>
                        <h1 class="story-card__headline">{s.headline}</h1>
                    </a>

                    <p class="body-copy story-card__description">
                        {s.description}
                    </p>
                </li>
            {/each}
        </ul>
    </div>
</div>

<style lang="scss">
    .readmore {
        margin: var(--spacing0) auto;

        &__copy {
            margin: 1em 0;
            line-height: var(--scale0);
        }
    }

    .readmore__header {
        font-size: var(--scale1) !important;
        font-weight: bold;
    }

    .readmore__header a {
        color: var(--color-text-body);
    }

    .readmore__items {
        display: grid;
        margin: var(--spacing0) 0;
        gap: var(--spacing0);
        grid-template-columns: repeat(1, 1fr);
        list-style-type: none !important;

        @media only screen and (width >= 48em) {
            grid-template-columns: repeat(3, 1fr);
        }

        &__item {
            line-height: var(--scale1);

            a {
                .story-card__headline {
                    margin: var(--scale-3) 0;
                    color: var(--color-text-body);
                    font-family: 'Tiempos Headline', 'Tiempos Text', Georgia, 'Times New Roman', serif;
                    font-size: var(--scale0);
                    font-weight: bold;
                    line-height: var(--scale2);

                    &:hover {
                        color: #06aee0;
                    }
                }
            }
        }
    }
</style>
